export default "__VITE_ASSET__Cod10KjA__"